export default __webpack_public_path__ + "ec303a0c645a90043bbac08a6fb89e60.png";